export default __webpack_public_path__ + "static/media/title.2fb41ccd.svg";